
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19 9h-2.58l3.29-3.29a1.004 1.004 0 10-1.42-1.42L15 7.57V5a1 1 0 10-2 0v5a1 1 0 001 1h5a1 1 0 100-2zm-9 4H5a1 1 0 000 2h2.57l-3.28 3.29a1 1 0 000 1.42.998.998 0 001.42 0L9 16.42V19a1 1 0 102 0v-5a1 1 0 00-1-1z","fill":"#9499A6"}})])
          )
        }
      }
    